import queryString from 'qs';
import moment from 'moment';

const getSelloutMonitoringRequest = (payload) => {
    let selloutDate = [moment().startOf('month'), moment()];
    if (Array.isArray(payload.sellout_date)) {
        selloutDate = payload.sellout_date;
    } else if (payload.sellout_date) {
        selloutDate = [payload.sellout_date];
    }

    const startDate = selloutDate?.[0];
    const endDate = selloutDate?.[1] ?? startDate;

    const data = {
        group_type: payload?.groupType?.name ?? null,
        group: payload?.custGroup?.id ?? null,
        customer_id: payload?.customer?.id ?? null,
        start_date: startDate ? moment(startDate?.format()).format('YYYY-MM-DD') : null,
        end_date: endDate ? moment(endDate?.format()).format('YYYY-MM-DD') : null,

        brand: payload?.brand?.length > 0 ? payload.brand.join(',') : null,
        agg: payload?.agg?.length > 0 ? payload.agg.join(',') : null,
        product: payload?.product?.length > 0 ? payload.product.join(',') : null,
        dc: payload?.dc?.length > 0 ? payload.dc.join(',') : null,

        limit: payload?.limit,
        page: payload?.page,
        sort: payload?.sort ? `${payload.sort.name}.${payload.sort.type}` : null,
        search: payload?.search ?? null,
    };
    return { queries: queryString.stringify(data, { skipNulls: true }), enabled: payload?.enabled };
};

export default getSelloutMonitoringRequest;
